import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const Border = styled.div<Pick<CardProps, 'shadowColour' | 'alignCenter'>>`
  padding: ${({ theme }) => theme.designToken.spacing4};
  background-color: ${({ theme }) => theme.designToken.baseWhite};
  display: flex;
  ${({ shadowColour }) => {
    if (shadowColour) {
      return `box-shadow: 0px 12px 34px 0px ${shadowColour};`;
    }
  }}

  ${({ alignCenter }) => {
    if (alignCenter) {
      return `
        justify-content: center;
        align-items: center;
        flex-direction: column;
      `;
    }
  }}
`;

export interface CardProps extends IntrinsicProps, StylableComponent {
  shadowColour?: string;
  alignCenter?: boolean;
}

export const Card = ({ children, ...props }: PropsWithChildren<CardProps>) => {
  return <Border {...props}>{children}</Border>;
};
